module.exports = __webpack_public_path__ + "img/47.c576bbf0.jpg";